/* Highside Lab — Sticky Add to Cart bar behavior */
(function () {
  function init(bar) {
    var sectionId = bar.getAttribute('data-section-id');
    var submitId = bar.getAttribute('data-submit-id');
    var realSubmit = document.getElementById(submitId);
    var stickyButton = document.getElementById('StickyAddToCartButton-' + sectionId);

    if (!realSubmit || !stickyButton) return;

    // Reveal the bar once JS is ready (avoids flash on load, respects [hidden]).
    bar.removeAttribute('hidden');

    // Proxy click: trigger the theme's real add-to-cart button so all
    // existing variant / sold-out / cart-drawer logic keeps working.
    stickyButton.addEventListener('click', function () {
      if (realSubmit.disabled) return;
      realSubmit.click();
    });

    // Keep sticky button's disabled/label state in sync with the real one
    // (variant changes toggle the real button's disabled + text via
    // product-form.js / product-info.js already).
    var syncState = function () {
      stickyButton.disabled = realSubmit.disabled;
      stickyButton.textContent = realSubmit.textContent.trim() || stickyButton.textContent;
    };

    var stateObserver = new MutationObserver(syncState);
    stateObserver.observe(realSubmit, { attributes: true, childList: true, subtree: true });

    // Show the bar only once the real button has scrolled out of view
    // (i.e. the shopper is scrolling through description/reviews/etc).
    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.classList.remove('sticky-atc--visible');
            } else {
              // Only show once we've scrolled past it going down, not before
              // the buy box has ever appeared on load.
              if (entry.boundingClientRect.top < 0) {
                bar.classList.add('sticky-atc--visible');
              }
            }
          });
        },
        { threshold: 0 }
      );
      visibilityObserver.observe(realSubmit);
    } else {
      bar.classList.add('sticky-atc--visible');
    }
  }

  document.querySelectorAll('.sticky-atc').forEach(init);
})();
